export class ProductRule {
  public id : number;
  public title: string;
  public name: string;
  public products: Object;
  public type: string;
  public description;
  public variations;

  constructor(payload) {
    this.id = payload.id;
    this.title = payload.title;
    this.name = payload.name;
    this.description = payload.description;
    this.products = payload.products;
    this.type = payload.type;
    this.variations = payload.variations;
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/product_rule.ts